import script from "./iconMinus.vue?vue&type=script&setup=true&lang=js"
export * from "./iconMinus.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__